import { daysInMonth, parseISODate, toISODate } from "./date";
import type { EnabledCanolaMonthCode, ISODate } from "./types";

export const LEAP_DAY_POLICY = "exclude-feb-29" as const;

const DELIVERY_MONTH: Readonly<Record<EnabledCanolaMonthCode, number>> = {
  F: 1,
  H: 3,
  K: 5,
  N: 7,
  X: 11,
};

export interface SeasonalityWindow {
  readonly canolaMonthCode: EnabledCanolaMonthCode;
  readonly contractYear: number;
  readonly start: ISODate;
  readonly end: ISODate;
  readonly leapDayPolicy: typeof LEAP_DAY_POLICY;
}
export function getSeasonalityWindow(
  canolaMonthCode: EnabledCanolaMonthCode,
  contractYear: number,
): SeasonalityWindow {
  if (!Number.isInteger(contractYear) || contractYear < 1900 || contractYear > 9999) {
    throw new Error(`Invalid contract year: ${contractYear}`);
  }
  const deliveryMonth = DELIVERY_MONTH[canolaMonthCode];
  const startYear = contractYear - 1;
  const endMonth = deliveryMonth === 1 ? 12 : deliveryMonth - 1;
  const endYear = deliveryMonth === 1 ? contractYear - 1 : contractYear;

  return {
    canolaMonthCode,
    contractYear,
    start: toISODate(startYear, deliveryMonth, 1),
    end: toISODate(endYear, endMonth, daysInMonth(endYear, endMonth)),
    leapDayPolicy: LEAP_DAY_POLICY,
  };
}

/** Month/day key for cross-year alignment. Feb 29 is excluded, never imputed. */
export function toSeasonalDayKey(date: ISODate): `${number}-${number}` | null {
  const { month, day } = parseISODate(date);
  if (month === 2 && day === 29) {
    return null;
  }
  return `${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}` as `${number}-${number}`;
}
